export default __webpack_public_path__ + "static/media/heroImageSm.b97a404a.png";